export const colors = {
    primary: {
        900: '#0F1865',
        800: '#1E297A',
        700: '#263286',
        600: '#2E3B92',
        500: '#34439B',
        400: '#525EA9',
        300: '#707AB7',
        200: '#989FCC',
        100: '#C0C4E0',
        50: '#E6E8F2',
    },
    secondary: {
        900: '#97165E',
        800: '#BE1B67',
        700: '#D41E6B',
        600: '#EB2170',
        500: '#FD2474',
        400: '#FD458A',
        300: '#FF67A1',
        200: '#FF93BC',
        100: '#FEBED7',
        50: '#FFE5EF',
    },
    bodyBG: '#EDEDED',
    darker: '#000000',
    dark: '#212121',
    white: '#ffffff',
    error: '#ff0000',
};

export const fonts = {
    primary: 'Rozha One, sans-serif',
    secondary: `Helvetica, Arial, sans-serif`,
};
